export const OUT_OPEN_TYPE = {
    HTML: "html",
    WEB_LINK: "webLink",
    FILE: "file",
    AUDIO: "audio",
    VIDEO: "video",
    FOLDER: "folder"
}